// src/slices/price/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getAnimalPrices = createAsyncThunk("animalPrice/getAll", async (payload, thunkAPI) => {
  try {
    const endpoint = typeof payload === "string" ? payload : payload?.endpoint;

    const params = typeof payload === "object" ? payload?.params || {} : {};


    const response = await axios.get(`${API_URL}${endpoint}`, { params });


    return { endpoint, data: response };
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});
